module.exports = __webpack_public_path__ + "img/LogoVEQCapital_Color.be624990.png";